export const CMI5 = {
    LAUNCH_MODE: {
        BROWSE: "Browse",
        REVIEW: "Review",
        NORMAL: "Normal" //like credit in scorm
    },
    // https://help.csod.com/help/csod_0/Content/Catalog/xAPI_Package_Support/xAPI_Appendix.htm
    VERBS: {
        PASSED: "http://adlnet.gov/expapi/verbs/passed",
        FAILED: "http://adlnet.gov/expapi/verbs/failed",
        COMPLETED: "http://adlnet.gov/expapi/verbs/completed"
    },
    SuccessStatus: {
        PASSED: "passed"
    },
    CompletionStatus: {
        COMPLETED: "completed",
        INCOMPLETE: "incomplete",
        NOT_ATTEMPTED: "not attempted",
        UNKNOWN: "unknown"
    }
};
